
import { defineComponent } from "vue";

import ConsentMedia from "~/vue/organisms/consents/ConsentMedia.vue";

export default defineComponent({
	components: {
		"consent--media": ConsentMedia,
	},
});
